import { useLocation } from '@tanstack/react-router';
import { track } from './track.js';
import type { TrackingEvents } from './types.js';

export function useTrack(category?: string) {
  const { pathname } = useLocation();

  return <E extends keyof TrackingEvents>(event: E, properties: TrackingEvents[E]) => {
    track(event, properties, { page: pathname, category });
  };
}
